export default "__VITE_ASSET__1c8e86e2__"